<template>
    <div style="border-radius: 10px; background: #fff; padding: 10px">
        <div class="handle-box">
            <div style="display: flex">
                <div>
                    时间：
                    <el-date-picker
                        v-model="dateTime"
                        type="datetimerange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @blur="getTime"
                        @change="changeTime"
                        :default-time="['00:00:00', '23:59:59']"
                        :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                </div>
                <div>
                    产品：
                    <el-select v-model="query.style_no" filterable multiple clearable placeholder="请选择" class="handle-select mr10">
                        <el-option
                            v-for="item in allSelect.style"
                            :key="item.style_no"
                            :label="item.style_name"
                            :value="item.style_no"
                        ></el-option>
                    </el-select>
                </div>
                <div v-if="systemSet.isstores == 1">
                    门店：
                    <el-select v-model="query.store_no" filterable multiple clearable placeholder="请选择" class="handle-select mr10">
                        <el-option
                            v-for="item in allSelect.store"
                            :key="item.store_no"
                            :label="item.store_name"
                            :value="item.store_no"
                        ></el-option>
                    </el-select>
                </div>
                <el-button type="primary" @click="searchIt" style="margin-left: 20px">{{ $t('common.confirm') }}</el-button>
            </div>
            <div class="right">
                <el-button type="primary" @click="handleAdd" v-if="perData.allow_add == 1">{{ $t('common.add') }}</el-button>
                <el-dropdown trigger="click" @command="handleCommand" style="margin-left: 10px">
                    <el-button plain> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1" v-if="perData.allow_add == 1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="perData.allow_add == 1">反审</el-dropdown-item>
                        <el-dropdown-item command="3" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-table :data="tableData" @selection-change="handleSelectionChange" border stripe style="width: 100%; font-size: 14px">
            <el-table-column type="selection" width="40" fixed="left"> </el-table-column>

            <el-table-column width="50" prop="id" label="id"></el-table-column>
            <el-table-column width="120" prop="store_name" label="门店" v-if="systemSet.isstores == 1"></el-table-column>
            <el-table-column width="180" prop="goldprice_date" label="金价日期"></el-table-column>
            <el-table-column width="120" prop="style_name" label="产品"></el-table-column>
            <el-table-column width="120" prop="bid_price" label="回购价"></el-table-column>
            <el-table-column width="120" prop="ask_price" label="销售价"></el-table-column>
            <el-table-column width="120" prop="updown_price" label="涨跌幅"></el-table-column>
            <el-table-column width="120" prop="high_price" label="最高价"></el-table-column>
            <el-table-column width="120" prop="low_price" label="最低价"></el-table-column>
            <el-table-column width="120" prop="open_price" label="开盘价"></el-table-column>
            <el-table-column width="120" prop="colse_price" label="收盘价"></el-table-column>
            <el-table-column width="120" prop="remark" :label="$t('common.remark')"></el-table-column>
            <el-table-column label="是否审核" align="center" width="120">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.check == '1' ? 'success' : scope.row.check == '0' ? 'danger' : ''">{{
                        scope.row.check == 1 ? '是' : '否'
                    }}</el-tag>
                    <el-switch
                        style="margin-left: 5px"
                        v-model="scope.row.check"
                        :active-value="1"
                        :inactive-value="0"
                        @change="tableDatastates(scope.row, 'check')"
                    >
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column width="180" prop="check_no" :label="$t('common.auditor')"></el-table-column>
            <el-table-column width="180" prop="check_date" :label="$t('common.auditTime')"></el-table-column>
            <el-table-column width="180" prop="build_no" :label="$t('common.creator')"></el-table-column>
            <el-table-column width="180" prop="build_date" :label="$t('common.createTime')"></el-table-column>
            <el-table-column width="180" prop="modify_no" :label="$t('common.modifier')"></el-table-column>
            <el-table-column width="180" prop="modify_date" :label="$t('common.modifyTime')"></el-table-column>

            <el-table-column label="是否通用门店" align="center" width="120" v-if="systemSet.isstores == 1">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.isstoregeneral == '1' ? 'success' : scope.row.isstoregeneral == '0' ? 'danger' : ''">{{
                        scope.row.isstoregeneral == 1 ? '是' : '否'
                    }}</el-tag>
                    <el-switch
                        style="margin-left: 5px"
                        v-model="scope.row.isstoregeneral"
                        :active-value="1"
                        :inactive-value="0"
                        @change="tableDatastates(scope.row, 'isstoregeneral')"
                    >
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280" align="center">
                <template slot-scope="scope">
                    <!-- <el-button
                        type="warning"
                        plain
                        icon="el-icon-s-operation"
                        @click="handleEdit(scope, 'check')"
                        v-if="perData.allow_edit == 1"
                        >{{ $t('common.audit') }}</el-button
                    > -->
                    <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope, 'edit')" v-if="perData.allow_edit == 1"
                        >{{ $t('common.edit') }}</el-button
                    >
                    <el-button type="danger" icon="el-icon-delete" plain v-if="perData.allow_dele == 1" @click="handleDelete(scope.row)"
                        >{{ $t('common.delete') }}</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="query.page"
                :page-size="query.page_size"
                :page-sizes="[30, 50, 100]"
                :total="pageTotal"
                @current-change="handlePageChange"
                @size-change="pageSizeChange"
            ></el-pagination>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addData_isshow" width="40%">
            <el-form :rules="rules1" ref="addform" :model="form" label-width="100px">
                <div class="aaa">
                    <el-form-item label="门店" style="width: 50%" v-if="systemSet.isstores == 1">
                        <el-select
                            v-model="form.store_no"
                            style="width: 200px"
                            @change="changeStore"
                            filterable
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in allSelect.store"
                                :key="item.store_no"
                                :label="item.store_name"
                                :value="item.store_no"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否门店通用" v-if="systemSet.isstores == 1">
                        <el-tag :type="form.isstoregeneral == '1' ? 'success' : form.isstoregeneral == '0' ? 'danger' : ''">{{
                            form.isstoregeneral == '1' ? '是' : '否'
                        }}</el-tag>
                        <el-switch style="margin-left: 5px" v-model="form.isstoregeneral" :active-value="1" :inactive-value="0">
                        </el-switch>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="产品" style="width: 50%">
                        <el-select
                            v-model="form.style_no"
                            style="width: 200px"
                            @change="changeStore"
                            filterable
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in allSelect.style"
                                :key="item.style_no"
                                :label="item.style_name"
                                :value="item.style_no"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="回购价" style="width: 50%">
                        <el-input v-model="form.bid_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="销售价" style="width: 50%">
                        <el-input v-model="form.ask_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="涨跌幅" style="width: 50%">
                        <el-input v-model="form.updown_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="最高价" style="width: 50%">
                        <el-input v-model="form.high_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="最低价" style="width: 50%">
                        <el-input v-model="form.low_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="开盘价" style="width: 50%">
                        <el-input v-model="form.open_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="收盘价" style="width: 50%">
                        <el-input v-model="form.colse_price" type="number" style="width: 200px"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="金价日期" style="width: 50%">
                        <el-date-picker
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期"
                            v-model="form.goldprice_date"
                            style="width: 200px"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.remark')" style="width: 50%">
                        <el-input type="textarea" v-model="form.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clear()">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiCurrentPermisson,
    apiGoldprice,
    apiGoldpricePull,
    apiGoldpriceAdd,
    apiGoldpriceEdit,
    apiGoldpriceDels,
    apiGoldpriceCheck
} from '@/request/api';
export default {
    data() {
        let self = this; // 加上这句改变this就可以了
        return {
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            dataAll: [],
            rules1: {
                style_no: [{ required: true, message: '请选择产品', trigger: 'change' }]
            },
            query: {},
            isAdd: true,
            form: {},
            tableData: [],
            perData: '',
            pageTotal: 0,
            dateTime: '',
            addData_isshow: false,
            allSelect: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            if (self.tabPosition !== 'today') {
                                self.tabPosition = 'today'; // 设置tab位置为今天
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0); // 设置开始时间为今天的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为今天的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            if (self.tabPosition !== 'zuori') {
                                self.tabPosition = 'zuori'; // 设置tab位置为昨日
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24); // 设置为昨日的时间
                            start.setHours(0, 0, 0, 0); // 设置开始时间为昨日的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为昨日的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            if (self.tabPosition !== 'benyue') {
                                self.tabPosition = 'benyue'; // 设置tab位置为本月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            const start = new Date(currentYear, currentMonth, 1); // 本月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 本月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为本月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            if (self.tabPosition !== 'shangyue') {
                                self.tabPosition = 'shangyue'; // 设置tab位置为上月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();

                            // 如果当前月份是1月（即0月），则上个月是去年12月
                            if (currentMonth === 0) {
                                currentMonth = 11; // 上个月是12月
                                currentYear--; // 年份减1
                            } else {
                                currentMonth--; // 上个月
                            }
                            const start = new Date(currentYear, currentMonth, 1); // 上月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 上月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为上月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    }
                ]
            }
        };
    },
    created() {
        // 获取当前日期
        const today = new Date();

        // 设置开始时间为今天的 00:00:00
        const start = new Date(today);
        start.setHours(0, 0, 0, 0);

        // 设置结束时间为今天的 23:59:59
        const end = new Date(today);
        end.setHours(23, 59, 59, 999);

        // 将设置的时间转换成字符串格式，如果需要
        const beginDate = this.formatDate(start);
        const endDate = this.formatDate(end);

        // 更新表单的开始和结束日期
        this.form.begin_date = beginDate;
        this.form.end_date = endDate;

        // 用于保存当前月份的日期范围
        const thisMonth = [beginDate, endDate];
        this.dateTime = thisMonth;

        this.getData();
        this.getPermission();
        this.getPull();
    },
    methods: {
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData_isshow = true;
            this.isAdd = true;
            this.form = {
                check: '0',
                bid_price: '0',
                ask_price: '0',
                updown_price: '0',
                high_price: '0',
                low_price: '0',
                open_price: '0',
                colse_price: '0',
                isstoregeneral: '0',
                goldprice_date: this.formatDate(new Date())
            };
            if (this.allSelect.store) {
                const defaultStore = this.allSelect.store.find((store) => store.isdefault == 1);
                this.form.store_no = defaultStore ? defaultStore.store_no : '';
            }
            if (this.allSelect.style) {
                const defaultStore = this.allSelect.style.find((style) => style.isdefault == 1);
                this.form.style_no = defaultStore ? defaultStore.style_no : '';
            }
        },
        changeStore() {
            this.$nextTick(() => {
                this.$refs.addform.validateField('style_no');
            });
            this.$forceUpdate();
        },
        // 编辑操作----------------------------------------------------------------------
        handleEdit(scope, type) {
            this.form = scope.row;
            if (type == 'check') {
                apiGoldpriceCheck({ id: this.form.id }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: res.msg, type: 'success' });
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                this.addData_isshow = true;
                this.isAdd = false;
                // ['style_no', 'store_no'].forEach((key) => {
                //     if (typeof scope.row[key] == 'string') {
                //         this.form[key] = scope.row[key].split(',');
                //     }
                // });
            }
        },

        // 启用按钮
        tableDatastates(row, type) {
            if (type == 'isstoregeneral') {
                apiGoldpriceEdit({ ...row }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: res.msg, type: 'success' });
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else if (type == 'check') {
                apiGoldpriceCheck({ id: row.id, check: row.check }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: res.msg, type: 'success' });
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        saveAdd() {
            let data = this.form;
            // console.log(data, 'data');
            this.$refs.addform.validate((valid) => {
                // 检查是否有字段为0，如果是，则阻止添加操作
                if (!data.style_no) {
                    this.$message.error('请选择产品');
                    return; // 阻止继续执行
                } else if (
                    data.bid_price == '0' &&
                    data.ask_price == '0' &&
                    data.updown_price == '0' &&
                    data.high_price == '0' &&
                    data.low_price == '0' &&
                    data.open_price == '0' &&
                    data.colse_price == '0'
                ) {
                    this.$message.error('不能全部为0');
                    return; // 阻止继续执行
                }
                if (valid) {
                    // ['store_no', 'style_no'].forEach((key) => {
                    //     if (data[key]) {
                    //         data[key] = data[key].join(',');
                    //     }
                    // });
                    if (this.isAdd) {
                        apiGoldpriceAdd(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '添加成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    } else {
                        apiGoldpriceEdit(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '修改成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    }
                } else {
                    return;
                }
            });
        },
        changeTime(val) {
            if (val == null) {
                this.$message.error('时间不能为空,已默认为当天');
                setTimeout(() => {
                    this.form.begin_date = this.formatDate(new Date());
                    this.form.end_date = this.formatDate(new Date());
                    const thisMonth = [];
                    thisMonth.push(this.form.begin_date, this.form.end_date);
                    this.dateTime = thisMonth;
                    this.getData();
                }, 500);
            } else {
                this.tabPosition = '';
            }
        },
        getTime(event) {
            this.form.begin_date = event.displayValue[0];
            this.form.end_date = event.displayValue[1];
        },
        formatDate(date) {
            const pad = (num) => num.toString().padStart(2, '0'); // 补零函数
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // 返回带时分秒的完整时间
        },
        // 多选删除操作
        handleSelectionChange(row) {
            this.dataAll = row;
        },
        // 批量操作
        handleCommand(command) {
            this.command = command;
            if (this.dataAll.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            let idArr = [];
            this.dataAll.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            if (command == 3) {
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    apiGoldpriceDels({
                        id: ids
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success(res.msg);
                            this.searchIt();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                });
            } else if (command == 2) {
                apiGoldpriceCheck({ id: ids, check: '0' }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: res.msg, type: 'success' });
                        this.searchIt();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else if (command == 1) {
                apiGoldpriceCheck({ id: ids, check: '1' }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: res.msg, type: 'success' });
                        this.searchIt();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        handleDelete(row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                apiGoldpriceDels({
                    id: row.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success(res.msg);
                        this.searchIt();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });
        },
        clear() {
            this.addData_isshow = false;
            this.form = {};
            this.searchIt();
        },
        searchIt() {
            this.query.page = 1;
            this.query.page_size = 10;
            this.getData();
        },
        // 获取页面信息-----------------------------------------
        getData() {
            this.$load.show();
            apiGoldprice({
                ...this.query
            }).then((res) => {
                // console.log(res, 'data');
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '22'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取下拉
        getPull() {
            apiGoldpricePull({}).then((res) => {
                if (res.code == 2000) {
                    // console.log(res, 'pull');
                    this.allSelect = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style lang="scss" scoped >
.handle-box {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
}
.handle-select {
    width: 200px;
}
.handle-input {
    width: 300px;
    display: inline-block;
}
.mr10 {
    margin-right: 10px;
}

.aaa {
    display: flex;
}
</style>
